import { render, staticRenderFns } from "./ProjectsCreate.vue?vue&type=template&id=f72ba75e&scoped=true"
import script from "./ProjectsCreate.vue?vue&type=script&lang=js"
export * from "./ProjectsCreate.vue?vue&type=script&lang=js"
import style0 from "./ProjectsCreate.vue?vue&type=style&index=0&id=f72ba75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72ba75e",
  null
  
)

export default component.exports